import React from "react";
import { Col } from "antd";
import { BREAKPOINTS } from "../../../constants/styles";
import CustomRow from "../../../shared/costum-row/costum-row";
import Usp from "../../../components/usp/usp";
import TeaserHome from "../../../components/teaster-home/teaser-home";
// import CaseCard from "../../../components/case-card/case-card";
import ContactUs from "../../../components/contact-us/contact-us";
import NewHeroSection from "../../../components/new-hero-section/new-hero-section";
import useBreakpoints from "../../../hooks/use-breakpoints";
import HomeHeadline from "../../../components/home-headline/home-headline";
import { USP_VALUES } from "../../../constants/content/shared/values";
import { HOME_CONTENT } from "../../../constants/content/pages/home";
import { CASES_CONTENT } from "../../../constants/content/pages/cases";
import CardSlider from "../../../components/card-slider/card-slider";
import "./styles.scss";

const Home: React.FC = () => {
  const currentBreakpoint = useBreakpoints();
  const isMobile =
    currentBreakpoint === BREAKPOINTS.MOBILE.type ||
    currentBreakpoint === BREAKPOINTS.TABLET.type;

  const slides = CASES_CONTENT.caseProjects.slice(0, 3).map((project, index) => ({
    id: String(index + 1).padStart(2, "0"),
    title: project.title,
    description: project.description,
    buttonText: "Learn more",
    imageUrl: project.heroImage || project.imageSrc,
  }));
  
  return (
    <div className="home-page">
      <NewHeroSection />
      <CustomRow
        gutter={[isMobile ? 16 : 60, 40]}
        isMarginNone
        isEdgeToEdge
        className="home-usps"
      >
        {USP_VALUES.map((usp) => (
          <Col key={usp.type} xxl={6} xl={6} lg={6} md={12} sm={12} xs={12}>
            <Usp type={usp.type} title={usp.title} description={usp.description} />
          </Col>
        ))}
      </CustomRow>
      <div className="home-content">
        <TeaserHome />
        <div className="home-content-spacing">
          <HomeHeadline
            title={HOME_CONTENT.headline.title}
            subtitle={HOME_CONTENT.headline.subtitle}
          />
        </div>
        <CardSlider slides={slides} />
      </div>

      <ContactUs />
    </div>
  );
};

export default Home;
